import api from "../../../utils/apiService";
import { ENDPOINT } from "../../../config/endpoints";

/**
 * Uplifted from `redux-store/saga/cashRegister` (apps/web + apps/mobile).
 *
 * A SPLIT, but a narrow one: two of the three workers are byte-identical and live here; only
 * `fetchCashSettlementDetails` diverges, so it — and `root`, which references all three — sit in
 * the platform files. That is the house style for a divergent FUNCTION (`getBasicSaleData`).
 *
 * The divergence: web's `saveCashSettlementDetails` payload carries two extra fields,
 * `branchSwitchData` and `switchUserData` (both `|| {}`), which mobile never sends. That is
 * consistent with the slice's own known split — web's `CASH_REGISTER_MODAL_TYPES` has a fourth
 * key, `close_switch_user`, that mobile's does not (ledger, `utils/constants`).
 *
 * ⚠️ Bare folder imports are REQUIRED in a `shared.ts` (hazard 16): both targets are
 * platform-split folders, and this file runs on both platforms.
 *
 * Note what is NOT imported here: `put` and `saveCashSettlementDetails`. Only the divergent
 * worker dispatches, so those belong to the platform files. Importing them here would be a dead
 * binding of exactly the kind hazard 13 warns the uplift itself can introduce.
 */

/** Identical in both apps. */
export function* openCashRegisterFunc(actions: any): Generator<any, void, any> {
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.CASH_REGISTER.openCashRegister,
      data: actions?.payload?.dataToPost,
    });
    actions?.payload?.callback && actions?.payload?.callback(response);
  } catch (error) {
    actions?.payload?.callback && actions?.payload?.callback(false);
    console.log(error);
  }
}

/** Identical in both apps. */
export function* closeCashRegisterFunc(actions: any): Generator<any, void, any> {
  try {
    const response = yield api.request({
      method: "POST",
      url: ENDPOINT.CASH_REGISTER.closeCashRegister,
      data: actions?.payload?.dataToPost,
    });
    actions?.payload?.callback && actions?.payload?.callback(response);
  } catch (error) {
    actions?.payload?.callback && actions?.payload?.callback(false);
    console.log(error);
  }
}
